import { Pill } from "./Pill";
import { cn } from "./cn";
import type { SessionStatus } from "../../domain/types";
import { t } from "../../i18n";

type StatusTone = "neutral" | "accent" | "success" | "warn" | "danger" | "info";

const STATUS_MAP: Record<SessionStatus, { tone: StatusTone; dotClass: string; pulse: boolean }> = {
  draft: { tone: "neutral", dotClass: "bg-fg-subtle", pulse: false },
  provisioning: { tone: "info", dotClass: "bg-sky-400", pulse: true },
  running: { tone: "success", dotClass: "bg-emerald-400", pulse: true },
  interrupted: { tone: "warn", dotClass: "bg-amber-400", pulse: false },
  finalized: { tone: "accent", dotClass: "bg-accent-400", pulse: false },
  error: { tone: "danger", dotClass: "bg-rose-500", pulse: true },
};

interface StatusPillProps {
  status: SessionStatus;
}

export function StatusPill({ status }: StatusPillProps) {
  const cfg = STATUS_MAP[status];
  const label = t(`status.${status}` as const);
  return (
    <Pill tone={cfg.tone} monospace aria-live="polite" aria-label={`Durum: ${label}`}>
      <span className="relative grid h-2 w-2 place-items-center" aria-hidden>
        <span
          className={cn(
            "absolute inset-0 rounded-full opacity-60",
            cfg.dotClass,
            cfg.pulse && "animate-ping",
          )}
        />
        <span className={cn("relative h-1.5 w-1.5 rounded-full", cfg.dotClass)} />
      </span>
      {label}
    </Pill>
  );
}
